/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography, Box, Container, Grid, Card, Switch, Stack } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import { forEach } from 'lodash';
import axiosInstance from '../../utils/axiosInstance';
import SingleSelector from '../single-selector/singleSelector';
import { QOS_FPS_GRAPH, QOS_BITRATE_GRAPH, QOS_ERROR_GRAPH } from './debug-graph-options/debugGraphOptions';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" sx={{ display: value === index ? 'inline' : 'none' }}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function StreamQosStats() {
  const { adaptorType } = window;
  const sensorList = useSelector((state) => state.app.sensorList);
  const [sensor, setSensor] = useState(null);
  const sensorRef = useRef();
  const qosFpsGraphData = useRef([]);
  const qosBitrateGraphData = useRef([]);
  const qosErrorGraphData = useRef([]);

  const [refreshGraphs, setRefreshGraphs] = useState(false);
  const intervalRef = useRef();

  useEffect(
    () => () => {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
    },
    []
  );

  const fetchData = () => {
    const currDate = new Date().getTime();
    axiosInstance
      .get(`${window.location.protocol}//${sensorRef.current.host}/api/v1/sensor/qos`)
      .then((response) => {
        const { data } = response;
        console.log('qos stats: ', data);
        console.log('selected sensor', sensorRef.current);
        if (data.stats && sensorRef.current) {
          forEach(data.stats, (obj) => {
            if (obj.name === sensorRef.current.name) {
              if (Object.prototype.hasOwnProperty.call(obj, 'avgFps')) {
                let f = 0;
                for (let i = 0; i < qosFpsGraphData.current.length; i += 1) {
                  if (qosFpsGraphData.current[i].name === 'average fps') {
                    f = 1;
                    qosFpsGraphData.current[i].data.push([currDate, Number(obj.avgFps)]);
                  }
                }
                if (f === 0) {
                  qosFpsGraphData.current.push({
                    name: 'average fps',
                    data: [[currDate, Number(obj.avgFps)]],
                  });
                }
              }

              if (Object.prototype.hasOwnProperty.call(obj, 'avgFramecount')) {
                let f = 0;
                for (let i = 0; i < qosFpsGraphData.current.length; i += 1) {
                  if (qosFpsGraphData.current[i].name === 'average framecount') {
                    f = 1;
                    qosFpsGraphData.current[i].data.push([currDate, Number(obj.avgFramecount)]);
                  }
                }
                if (f === 0) {
                  qosFpsGraphData.current.push({
                    name: 'average framecount',
                    data: [[currDate, Number(obj.avgFramecount)]],
                  });
                }
              }

              if (Object.prototype.hasOwnProperty.call(obj, 'encoderFps')) {
                let f = 0;
                for (let i = 0; i < qosFpsGraphData.current.length; i += 1) {
                  if (qosFpsGraphData.current[i].name === 'encoder fps') {
                    f = 1;
                    qosFpsGraphData.current[i].data.push([currDate, Number(obj.encoderFps)]);
                  }
                }
                if (f === 0) {
                  qosFpsGraphData.current.push({
                    name: 'encoder fps',
                    data: [[currDate, Number(obj.encoderFps)]],
                  });
                }
              }

              if (Object.prototype.hasOwnProperty.call(obj, 'bitrateKbpsAvg')) {
                let f = 0;
                for (let i = 0; i < qosBitrateGraphData.current.length; i += 1) {
                  if (qosBitrateGraphData.current[i].name === 'average bitrate') {
                    f = 1;
                    qosBitrateGraphData.current[i].data.push([currDate, Number(obj.bitrateKbpsAvg)]);
                  }
                }
                if (f === 0) {
                  qosBitrateGraphData.current.push({
                    name: 'average bitrate',
                    data: [[currDate, Number(obj.bitrateKbpsAvg)]],
                  });
                }
              }

              if (Object.prototype.hasOwnProperty.call(obj, 'errors')) {
                let f = 0;
                for (let i = 0; i < qosErrorGraphData.current.length; i += 1) {
                  if (qosErrorGraphData.current[i].name === 'error bit') {
                    f = 1;
                    qosErrorGraphData.current[i].data.push([currDate, obj.errors.length === 0 ? 0 : 1]);
                  }
                }
                if (f === 0) {
                  qosErrorGraphData.current.push({
                    name: 'error bit',
                    data: [[currDate, obj.errors.length === 0 ? 0 : 1]],
                  });
                }
              }
            }
          });

          ApexCharts.exec('qosFpsGraph', 'updateOptions', {
            series: qosFpsGraphData.current,
          });
          ApexCharts.exec('qosBitrateGraph', 'updateOptions', {
            series: qosBitrateGraphData.current,
          });
          ApexCharts.exec('qosErrorGraph', 'updateOptions', {
            series: qosErrorGraphData.current,
          });
        }
      })
      .catch((e) => {
        console.log('Failed to fetch system stats', e);
      });
  };

  const dataFetcher = () => {
    intervalRef.current = setInterval(() => {
      fetchData();
    }, 5000);
  };

  const cleanup = () => {
    /**
     * clean arrays
     */
    qosFpsGraphData.current = [];
    qosBitrateGraphData.current = [];
    qosErrorGraphData.current = [];
    ApexCharts.exec('qosFpsGraph', 'updateOptions', {
      series: qosFpsGraphData.current,
    });
    ApexCharts.exec('qosBitrateGraph', 'updateOptions', {
      series: qosBitrateGraphData.current,
    });
    ApexCharts.exec('qosErrorGraph', 'updateOptions', {
      series: qosErrorGraphData.current,
    });
  };

  const handleRefreshGraphs = () => {
    if (!refreshGraphs) {
      dataFetcher();
    } else {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
      cleanup();
    }
    setRefreshGraphs(!refreshGraphs);
  };

  const handleSetSensor = (val) => {
    cleanup();
    setSensor(val);
    sensorRef.current = val;
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" sx={{ mb: 5 }}>
        Stream QOS stats
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Box sx={{ p: 3 }}>
            <Stack direction="row" alignItems="center">
              <Typography>Off</Typography>
              <Switch checked={refreshGraphs} onChange={handleRefreshGraphs} />
              <Typography>On</Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <Box sx={{ p: 3 }}>
              <Stack spacing={3} sx={{ mb: 2 }}>
                <SingleSelector
                  id="qos-stream"
                  placeholder="Type to search"
                  label={`Select ${adaptorType === "streamer" ? "file" : "sensor"}`}
                  value={sensor}
                  onChange={handleSetSensor}
                  getOptionLabel={(option) => {
                    if (option.remoteDeviceName && option.remoteDeviceLocation) {
                      return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                    } if (option.remoteDeviceName) {
                      return `${option.name} at ${option.remoteDeviceName}`;
                    }
                    return option.name;

                  }}
                  options={sensorList}
                />
              </Stack>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ p: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={QOS_FPS_GRAPH} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ p: 3 }} dir="ltr">
              <ReactApexChart type="area" height={350} series={[]} options={QOS_BITRATE_GRAPH} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ p: 3 }} dir="ltr">
              <ReactApexChart type="line" height={350} series={[]} options={QOS_ERROR_GRAPH} />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
